Apt.fn.make('account.searches', {
	/**
	 * @private
	 */
	_construct() {
		this.app = 'searches';

		this.frequencies = {
			immediately: 'Immediate',
			daily: 'Daily',
			weekly: 'Weekly',
			never: 'No emails'
		};
	},

	/**
	 * Initialize module
	 */
	init() {
		const scope = this;
		const priv = scope.$private;

		scope.index = Apt.fn.index().init({
			app: scope.app,
			auth: true,
			view: $$('template')[0].textContent,
			path: 'account/searches',
			resource: 'me/searches',
			paginate: true,
			sorting: {
				'name': 'Alphabetical',
				'-newest': 'Newest'
			},
			model: {
				frequencies: scope.frequencies
			},
			transform: search => {
				const data = search.criteria || {};
				const loc = search.location;

				search.criteria = priv.transform(
					search.criteria || {}
				);

				if (loc) {
					data.location = (
						loc.postalCode || loc.locality ||
						loc.subterritory || loc.region ||
						loc.territory || loc.country
					).slug;
				}

				search.url = LS.filters.build('properties', data);
			}
		}, () => {
			priv.bind();
		});
	},

	/**
	 * Unload module
	 */
	unload() {
		LS.util.reset('search', this, 'index');
	}
}, {
	/**
	 * Transform search criteria
	 *
	 * @param {Object} criteria
	 */
	transform(criteria) {
		const formats = {
			age: value => value + ' ' + (value === '1' ? 'day' : 'days'),
			array: (value, or, key) => {
				const conjunction = or ?
					' or ' : ' and ';

				value = $.toArray(value).map(str => {
					if (
						key === 'tag' ||
						key === 'type'
					) {
						return LS[key + 's'][str] || '';
					}

					return LS.util.capitalize(str);
				})
					.filter(Boolean);

				if (value.length < 3) {
					return value.join(conjunction);
				}

				return value.slice(0, - 1)
					.join(', ') + ',' + conjunction + value[value.length - 1];
			},
			bool: value => {
				return value === '1' ?
					'Yes' : 'No';
			},
			object: value => {
				return value ?
					'Yes' : '-'
			},
			price: value => {
				return LS.util.formatRange(value, '$');
			},
			range: value => {
				return (value.min || 'Any') + '-' + (value.max || 'Any');
			},
			size: value => {
				return LS.util.formatRange(value, null, 'acre');
			},
			sort: value => {
				return Apt.properties.getSorting()[value];
			},
			space: value => {
				return LS.util.formatRange(value, null) + ' sq ft';
			}
		};
		const map = {
			bedrooms: [
				'Min bedrooms'
			],
			dom: [
				'Max listing age',
				'age'
			],
			format: [
				'Format',
				'array'
			],
			hoa: [
				'Show with HOA',
				'bool'
			],
			geometry: [
				'Drawing',
				'object'
			],
			images: [
				'Require images',
				'bool'
			],
			videos: [
				'Require video',
				'bool'
			],
			keywords: [
				'Keywords'
			],
			new_only: [
				'New only',
				'bool'
			],
			pending: [
				'Show pending',
				'bool'
			],
			price: [
				'Price',
				'price'
			],
			size: [
				'Size',
				'size'
			],
			sort: [
				'Sort',
				'sort'
			],
			space: [
				'Square feet',
				'space'
			],
			structure: [
				'House or building',
				'bool'
			],
			tag: [
				'Tag',
				'array'
			],
			type: [
				'Type',
				'array'
			],
			year: [
				'Year built',
				'range'
			]
		};

		const output = {};

		for (const [key, value] of Object.entries(criteria)) {
			const format = map[key];

			if (format) {
				const label = format[0];
				const type = format[1];

				if (format[1] === 'array') {
					const conjunction = key === 'format' ?
						true : criteria[key + '_any'];

					output[label] = formats[type](value, conjunction, key);
				} else {
					output[label] = format.length > 1 ?
						formats[type](value) : value;
				}
			}
		}

		return output;
	},

	/**
	 * Bind events
	 */
	bind() {
		const scope = this;
		const app = $.app[scope.$public.app];
		const editClass = '-is-editing';

		$.events.on({
			'$searchLink': {
				click: (e, el) => {
					const $search = $(el).closest('$search');

					LS.api.request('me/searches/' + $search.data('id'), {
						auth: true,
						namespace: 'search',
						method: 'patch',
						flash: false,
						data: {
							viewed_at: new Date().toISOString()
						}
					});
				}
			},
			'$searchEdit': {
				click: (e, el) => {
					const $search = $(el).closest('$search');
					const id = $search.data('id');

					let save = true;

					$search.addClass(editClass);

					$$('searchInput', $search)
						.focus(true)
						.on({
							blur: (e, el) => {
								if (save && el.value !== el.defaultValue) {
									scope.rename(id, el.value, () => {
										$search.removeClass(editClass);
									});
								} else {
									$search.removeClass(editClass);
								}
							},
							keydown: (e, el) => {
								const esc = e.keyCode === 27;

								if (esc || e.keyCode === 13) {
									if (esc) {
										save = false;
										el.value = el.defaultValue;
									}

									$search.removeClass(editClass);
								}
							}
						});
				}
			},
			'$searchFrequency': {
				change: (e, el) => {
					const id = $(el).closest('$search')
						.data('id');

					scope.patch(id, {
						frequency: el.value
					});
				}
			},
			'$searchDelete': {
				click: (e, el) => {
					const id = $(el).closest('$search')
						.data('id');

					LS.modal.confirm('Are you sure you want to delete this?', () => {
						LS.api.delete('me/searches/' + id, {
							auth: true,
							success: () => {
								app.$pause();

								app.$drop({
									'results.id': id
								});

								app.$set('total', app.$get('total') - 1);

								app.$resume(true);
							}
						});
					});
				}
			}
		}, {
			delegate: '$results',
			namespace: 'search'
		});
	},

	/**
	 * Rename saved search
	 *
	 * @param {String} id
	 * @param {String} name
	 * @param {Function} fn
	 */
	rename(id, name, fn) {
		this.patch(id, {
			name: name
		}, () => {
			$.app.searches.$set([
				'name', {
					'results.id': id
				}
			], name);

			fn();
		});
	},

	/**
	 * Update search values
	 *
	 * @param {String} id
	 * @param {Object} data
	 * @param {Function} [fn]
	 */
	patch(id, data, fn) {
		LS.api.request('me/searches/' + id, {
			auth: true,
			method: 'patch',
			data: data,
			success: () => {
				$.exec(fn);
			}
		});
	}
});